import dayjs from 'dayjs';
import Grade from './Grade.js';

export default class GradationalSalary {
  constructor(data) {
    this.id = data?.id;
    this.gradeId = data?.gradeId;
    this.rank = data?.rank ? Number(data.rank) : null;
    this.salary = data?.salary ? Number(data.salary) : null;
    this.isDeleted = data?.isDeleted ? Boolean(data.isDeleted) : false;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.grade = data?.grade ? new Grade(data?.grade) : null;
  }
}
